// extracted by mini-css-extract-plugin
export default {"root":"styles_root__DlD6p","forgot-button":"styles_forgot-button__WxU0t","buttons":"styles_buttons__NmDes","error":"styles_error__+B5-7"};